const initMediaUploadProgress = () => {
  const form = document.querySelector('[data-media-upload-form]');
  if (!form) return;

  const inputs = Array.from(form.querySelectorAll('[data-upload-kind]'));
  if (inputs.length === 0) return;

  const revokeUrls = [];

  const clearPreviews = kind => {
    const container = form.querySelector(`[data-upload-preview="${kind}"]`);
    if (!container) return;
    while (container.firstChild) container.removeChild(container.firstChild);
    container.classList.add('hidden');
  };

  const renderPreviews = (kind, files) => {
    const container = form.querySelector(`[data-upload-preview="${kind}"]`);
    if (!container) return;
    clearPreviews(kind);

    if (!files || files.length === 0) return;

    const frag = document.createDocumentFragment();
    Array.from(files).forEach(file => {
      if (file.type.startsWith('image/')) {
        const url = URL.createObjectURL(file);
        revokeUrls.push(url);
        const img = document.createElement('img');
        img.src = url;
        img.alt = `${kind} preview`;
        img.className = 'h-24 w-full rounded-lg border border-neutral-200 object-cover';
        frag.appendChild(img);
      } else if (file.type.startsWith('video/')) {
        const url = URL.createObjectURL(file);
        revokeUrls.push(url);
        const video = document.createElement('video');
        video.src = url;
        video.preload = 'metadata';
        video.controls = true;
        video.muted = true;
        video.playsInline = true;
        video.className = 'w-full max-w-sm rounded-lg border border-neutral-200';
        frag.appendChild(video);
      } else {
        const div = document.createElement('div');
        div.textContent = file.name || 'Selected file';
        div.className = 'rounded border border-neutral-200 bg-neutral-50 px-3 py-2 text-sm';
        frag.appendChild(div);
      }
    });

    container.appendChild(frag);
    container.classList.remove('hidden');
  };

  inputs.forEach(input => {
    input.addEventListener('change', event => {
      const kind = event.target.dataset.uploadKind;
      if (!kind) return;
      renderPreviews(kind, event.target.files);
    });
  });

  const blocks = {};
  form.querySelectorAll('[data-upload-progress]').forEach(el => {
    const kind = el.dataset.uploadProgress;
    if (!kind) return;
    blocks[kind] = {
      container: el,
      bar: el.querySelector('[data-upload-progress-bar]'),
      label: el.querySelector('[data-upload-progress-label]'),
      status: el.querySelector('[data-upload-status]')
    };
  });

  const uploads = {};
  const totals = {};

  const showBlock = kind => {
    const block = blocks[kind];
    if (block && block.container) block.container.classList.remove('hidden');
  };

  const renderKind = kind => {
    const block = blocks[kind];
    if (!block) return;
    const total = totals[kind] || 0;
    const loaded = Object.values(uploads)
      .filter(u => u.kind === kind)
      .reduce((sum, u) => sum + (u.loaded || 0), 0);

    const pct = total === 0 ? 0 : Math.min(1, loaded / total);
    const pctLabel = `${Math.round(pct * 100)}%`;

    if (block.bar) block.bar.style.width = pctLabel;
    if (block.label) block.label.textContent = pctLabel;

    if (block.status) {
      if (pct >= 1) {
        block.status.innerHTML = '<span aria-hidden="true">&#10003;</span><span>Upload complete</span>';
      } else {
        block.status.textContent = 'Uploading...';
      }
    }
  };

  const renderAll = () => {
    Object.keys(totals).forEach(renderKind);
  };

  form.addEventListener('direct-upload:initialize', event => {
    const { id, file } = event.detail;
    const input = event.target;
    const kind = input?.dataset?.uploadKind;
    if (!kind) return;

    uploads[id] = { kind, loaded: 0, total: file.size || 0 };
    totals[kind] = (totals[kind] || 0) + (file.size || 0);
    showBlock(kind);
    renderKind(kind);
  });

  form.addEventListener('direct-upload:progress', event => {
    const { id, progress } = event.detail;
    const upload = uploads[id];
    if (!upload) return;
    upload.loaded = Math.round((upload.total || 0) * (progress / 100));
    renderKind(upload.kind);
  });

  form.addEventListener('direct-upload:error', event => {
    const { id } = event.detail;
    const upload = uploads[id];
    if (!upload) return;
    const block = blocks[upload.kind];
    if (block && block.status) {
      block.status.textContent = 'Upload failed. Please try again.';
    }
  });

  form.addEventListener('direct-upload:end', event => {
    const { id } = event.detail;
    const upload = uploads[id];
    if (!upload) return;
    upload.loaded = upload.total || 0;
    renderKind(upload.kind);
  });

  // Removal handling for existing attachments
  const removeInputsContainer = form.querySelector('[data-remove-inputs]');

  const markRemoval = (button) => {
    const kind = button.dataset.removeAttachment;
    const attachmentId = button.dataset.attachmentId;
    if (!kind || !attachmentId || !removeInputsContainer) return;

    // prevent duplicate inputs
    const existing = removeInputsContainer.querySelector(
      `input[name="remove_${kind}_image_ids[]"][value="${attachmentId}"], input[name="remove_${kind}_image"][value="1"]`
    );
    if (existing) return;

    let input;
    if (kind === 'primary') {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'remove_primary_image';
      input.value = '1';
    } else if (kind === 'video') {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'remove_video';
      input.value = '1';
    } else if (kind === 'gallery') {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'remove_gallery_image_ids[]';
      input.value = attachmentId;
    }

    if (!input) return;
    removeInputsContainer.appendChild(input);

    const card = button.closest('[data-attachment-card]');
    if (card) {
      card.classList.add('opacity-60');
      const badge = card.querySelector('[data-removal-badge]');
      if (badge) badge.classList.remove('hidden');
    } else {
      const badge = button.parentElement?.querySelector('[data-removal-badge]');
      if (badge) badge.classList.remove('hidden');
    }

    button.disabled = true;
  };

  form.addEventListener('click', event => {
    const button = event.target.closest('[data-remove-attachment]');
    if (!button) return;
    event.preventDefault();
    markRemoval(button);
  });

  window.addEventListener('beforeunload', () => {
    revokeUrls.forEach(url => URL.revokeObjectURL(url));
  });
};

document.addEventListener('DOMContentLoaded', initMediaUploadProgress);

